import React, { useState, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import fr from 'facet-rest';
import DataContainer from 'Components/UI/DataContainer';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import { QueryVal } from 'Helpers/Query';
import BulkCommunicationSummaryDialogContent from './DialogContent';

const BulkCommunicationSummaryDialogContainer = ({
  classes,
  closeModal,
  ...rest
}) => {
  // Loading states
  const [loading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(false);

  // Bulk Communication Summary Resource
  const [bulkCommunicationSummaryResource, setBulkCommunicationSummary] = useState(null);

  const { rootNodeProps } = useEventTrackingLogEvent({ nodeName: 'Bulk Communication Dialog' });
  const location = useLocation();
  const bulkCommunicationSummaryLink = useMemo(() => (QueryVal('bulkCommunicationSummaryLink') || null), [location.search]);

  const FetchBulkCommunicationSummary = async () => {
    try {
      setLoading(true);
      const summaryCollection = await fr.http.get(bulkCommunicationSummaryLink);
      const summaryRes = summaryCollection.resources().head();
      setBulkCommunicationSummary(summaryRes);
    } catch (err) {
      setLoadingError(true);
      displayErrorMessage(err, 'Error fetching bulk communication summary');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    FetchBulkCommunicationSummary();
  }, [bulkCommunicationSummaryLink]);

  return (
    <DataContainer
      loading={loading}
      loadingError={loadingError}
      {...rootNodeProps}
    >
      <BulkCommunicationSummaryDialogContent
        bulkCommunicationSummaryResource={bulkCommunicationSummaryResource}
        {...rest}
      />
    </DataContainer>
  );
};

BulkCommunicationSummaryDialogContainer.defaultProps = {};
export default BulkCommunicationSummaryDialogContainer;
